import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BundleLoaderService } from './bundle-loader.service';

@Injectable({ providedIn: 'root' })
export class BundleIOHPreloadService {
  private readonly bundleLoader = inject(BundleLoaderService);
  private _loaded = false;

  preloadIohRealtimeInfoDetails(): void {
    if (this._loaded) return;
    const urls: string[] | undefined = environment?.appConfig?.webComponents?.realtimeOperationsInfo;
    if (urls && !customElements.get('csxwc-tos-imod-operations-info')) {
      urls.forEach((url: string) => this.bundleLoader.loadBundle(url));
      this._loaded = true;
    }
  }


}